import useSWR from 'swr';

import { usePrivate } from '@/components/private';
import { enqueueSnackbar } from '@/providers';

import { useGetOrganisationsByUserIdMessages } from './messages';

export interface useGetOrganisationsByUserIdOptions {
  shouldFetch?: boolean;
}

export function useGetOrganisationsByUserId(
  userId: number | null | undefined,
  options?: useGetOrganisationsByUserIdOptions,
) {
  const mergedOptions: useGetOrganisationsByUserIdOptions = {
    shouldFetch: true,
    ...options,
  };

  const { roleUserOrgAssociationApi } = usePrivate();

  const results = useSWR(
    roleUserOrgAssociationApi && mergedOptions.shouldFetch
      ? `/api/RoleUserOrgAssociation/GetByUserOrgId/${userId}`
      : null,
    () =>
      roleUserOrgAssociationApi?.apiRoleUserOrgAssociationGetByUserOrgIdGet(
        userId!,
      ),
    {
      onError: (error) => {
        enqueueSnackbar(
          useGetOrganisationsByUserIdMessages[
            'useGetOrganisationsByUserId.fetch.unexpectedError'
          ],
          {
            variant: 'error',
          },
        );
        console.error(
          '[BREEDLOGIC] <useGetOrganisationsByUserId> error fetching memberships.',
          error,
        );
      },
    },
  );

  const isLoadingOrValidating =
    results.isLoading || results.isValidating || !roleUserOrgAssociationApi;

  return { ...results, isLoadingOrValidating };
}
